import { Ingredient } from './ingredient.model';

export class Benchmark extends Ingredient{
  public is_private: boolean;
}
